<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';
    import {TextAlignmentTypes, UIText} from './text';
    import ConfigTextInput from "../utils/ConfigTextInput.svelte";
    import ConfigInput from "../utils/ConfigTextInput.svelte";
    import {UIElement} from '../element';
    import {OriginCoords} from '../../types';
    import ConfigTextAreaInput from "../utils/ConfigTextAreaInput.svelte";
    import ConfigCheckbox from "../utils/ConfigCheckbox.svelte";
    import ConfigDropdownSelect from "../utils/ConfigDropdownSelect.svelte";
    import {isStringNumber} from "../../utils/helpers";

    export let uiElement: UIText;
    export let origin: OriginCoords;

    let nameValue = uiElement.name;
    let xValue = uiElement.x.toString();
    let yValue = uiElement.y.toString();
    let widthValue = uiElement.width.toString();
    let heightValue = uiElement.height.toString();
    let textValue = uiElement.text;
    let fontSizeValue = uiElement.fontSize;
    let lineCountValue = uiElement.lineCount;
    let boxShowValue = uiElement.boxShowing;
    let textAlignmentValue = uiElement.textAlignment;
    let fitTextValue = uiElement.fitText;
    let groupValue = uiElement.group;
    let textAlignmentOptions = [TextAlignmentTypes.LEFT, TextAlignmentTypes.CENTER];
    let zValue = uiElement.z;
    function onValueChange(attributeName: keyof UIText | keyof UIElement, parseValueToInt = true) {
        return (value) => {
            uiElement[attributeName] = parseValueToInt ? parseInt(value.detail) : value.detail;
            guiCreatorDataStore.update(uiElement);
        }
    }


</script>

<div>

    <div class="flex flex-row bg-center pt-1">
        <p class="text-lg ">Info: Text</p>
    </div>

    <ConfigTextInput value="{nameValue}" on:configValueChanged={onValueChange('name', false)}
                     title="Name"></ConfigTextInput>
    <ConfigInput value="{groupValue || ''}" on:configValueChanged={onValueChange('group', false)}
                 title="Group"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Position</p>
    </div>
    <ConfigTextInput value="{xValue}" on:configValueChanged={onValueChange('x', true)}
                     title="X"></ConfigTextInput>
    <ConfigTextInput value="{yValue}" on:configValueChanged={onValueChange('y', true)}
                     title="Y"></ConfigTextInput>
    <ConfigInput value="{zValue}" on:configValueChanged={onValueChange('z', true)}
                 title="Z"></ConfigInput>

    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Dimensions</p>
    </div>
    <ConfigCheckbox value="{boxShowValue}" title="Show Border"
                    on:configValueChanged={onValueChange('boxShowing', false)}></ConfigCheckbox>
    <ConfigTextInput value="{widthValue}" on:configValueChanged={onValueChange('width', true)}
                     title="Width"></ConfigTextInput>
    <ConfigTextInput active="{false}" value="{heightValue}"
                     on:configValueChanged={onValueChange('height', true)}
                     title="Height"></ConfigTextInput>
    <ConfigTextInput value="{lineCountValue}"
                     on:configValueChanged={onValueChange('lineCount', true)}
                     validator="{isStringNumber}" title="Lines"></ConfigTextInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Value</p>
    </div>
    <ConfigTextAreaInput value="{textValue}" on:configValueChanged={onValueChange('text', false)}
                         title="Text"></ConfigTextAreaInput>
    <ConfigTextInput value="{fontSizeValue}" on:configValueChanged={onValueChange('fontSize', true)}
                     validator="{isStringNumber}" title="FontSize"></ConfigTextInput>
    <ConfigDropdownSelect value="{textAlignmentValue}" options="{textAlignmentOptions}"
                          on:configValueChanged={onValueChange('textAlignment', false)}
                          title="Text Alignment"></ConfigDropdownSelect>
    <ConfigCheckbox value="{fitTextValue}" title="Fit Text"
                    on:configValueChanged={onValueChange('fitText', false)}></ConfigCheckbox>
</div>

<style>

    .text-input-combination {
        border-style: dashed;

        display: grid;
        grid-template-columns: 60px 80%;
    }
</style>
